import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { ApiMetaDataDTO } from 'declarations'
import { toast } from 'react-toastify'

import { client } from 'services/helpers/apiConfig'

type SearchRequisitionQueryParamsDTO = {
  term: string
  assignee?: string
  status?: string
  suppliers?: string
}

type SearchResultDTO = {
  search: {
    more_than_100: boolean
    record_count: number
    term_count: number
    terms: string[]
  }
}
type ApiResponseDTO = {
  code: number
  data: SearchResultDTO
  api_metadata: ApiMetaDataDTO
}

const useRfqSearchQuery = (
  params: SearchRequisitionQueryParamsDTO
): UseQueryResult<SearchResultDTO> => {
  return useQuery({
    queryKey: ['rfq', 'search', params.term, params.assignee, params.status],
    queryFn: async () => {
      try {
        const reqParams = {
          term: params.term,
          assignee: params.assignee,
          status: params.status,
          supplier_id: params.suppliers,
        }

        const res = await client.get<ApiResponseDTO>(`/rfq/search`, {
          params: reqParams,
        })

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
    enabled: params.term !== '',
  })
}

export { useRfqSearchQuery }
